"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const dom_event_utils_1 = require("../../../utils/dom-event-utils");
const SliderContext_1 = require("../SliderContext");
const SliderHelpers_1 = require("../SliderHelpers");
const SliderHooks_1 = require("../SliderHooks");
const SliderRail_1 = __importDefault(require("./SliderRail"));
const SliderTrack_1 = __importDefault(require("./SliderTrack"));
const SliderFilledTrack_1 = __importDefault(require("./SliderFilledTrack"));
const SliderThumb_1 = __importDefault(require("./SliderThumb"));
require("./SliderBase.scss");
const SliderBase = (0, react_1.forwardRef)(({ className }, _ref) => {
    const { color, disabled, size, shapeTestId } = (0, SliderContext_1.useSliderUi)();
    const { min, max, ranged, step, value } = (0, SliderContext_1.useSliderSelection)();
    const { changeThumbValue, drugThumb, decreaseValue, increaseValue } = (0, SliderContext_1.useSliderActions)();
    const { railCoords, railRef } = (0, SliderHooks_1.useSliderRail)();
    const { dimension, offset, positions, thumbKeys } = (0, SliderHelpers_1.calcDimensions)(max, min, ranged, value);
    const handlePointerMove = (0, react_1.useCallback)((e) => {
        const offsetInPx = Math.round(e.clientX - railCoords.left);
        const newValue = (0, SliderHelpers_1.moveToPx)(offsetInPx, min, max, railCoords, step);
        drugThumb(newValue);
    }, [drugThumb, min, max, railCoords, step]);
    const handleRailClick = (0, react_1.useCallback)((e) => {
        const offsetInPx = e.clientX - railCoords.left;
        const newValue = (0, SliderHelpers_1.moveToPx)(offsetInPx, min, max, railCoords, step);
        const thumbIndex = (0, SliderHelpers_1.getNearest)(newValue, ranged, value);
        changeThumbValue(newValue, thumbIndex);
    }, [changeThumbValue, min, max, railCoords, ranged, step, value]);
    function handleKeyDown(e) {
        if ((0, dom_event_utils_1.isArrowUpEvent)(e) || (0, dom_event_utils_1.isArrowRightEvent)(e)) {
            return increaseValue();
        }
        if ((0, dom_event_utils_1.isArrowDownEvent)(e) || (0, dom_event_utils_1.isArrowLeftEvent)(e)) {
            return decreaseValue();
        }
        if ((0, dom_event_utils_1.isPageUpEvent)(e)) {
            e.preventDefault();
            return increaseValue((0, SliderHelpers_1.calculatePageStep)(max, min, step));
        }
        if ((0, dom_event_utils_1.isPageDownEvent)(e)) {
            e.preventDefault();
            return decreaseValue((0, SliderHelpers_1.calculatePageStep)(max, min, step));
        }
        if ((0, dom_event_utils_1.isHomeEvent)(e)) {
            e.preventDefault();
            return changeThumbValue(min);
        }
        if ((0, dom_event_utils_1.isEndEvent)(e)) {
            e.preventDefault();
            return changeThumbValue(max);
        }
    }
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, SliderHelpers_1.bem)("base", { [size]: size, [color]: color, disabled }, className), "data-testid": shapeTestId("base"), onKeyDown: handleKeyDown }, { children: (0, jsx_runtime_1.jsxs)(SliderRail_1.default, Object.assign({ onClick: handleRailClick, ref: railRef }, { children: [(0, jsx_runtime_1.jsx)(SliderTrack_1.default, {}), railRef.current && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SliderFilledTrack_1.default, { dimension: dimension, offset: offset }), positions.map((position, index) => {
                            return ((0, jsx_runtime_1.jsx)(SliderThumb_1.default, { index: index, onMove: handlePointerMove, position: position }, thumbKeys[index]));
                        })] }))] })) })));
});
exports.default = SliderBase;
